<script setup lang="ts">
import { computed, ref } from 'vue'
import { StorageUsage } from '../../../../@core/lidar/domain/entities/StorageUsage'
import ProgressBar from '../../../../components/ui/progressBar/ProgressBar.vue'
import StorageRequestDialog from './StorageRequestDialog.vue'

const props = defineProps<{
	usage: StorageUsage
}>()

const emit = defineEmits<{
	(e: 'requestStorage'): void
}>()

const showDialog = ref(false)

const isStorageCritical = computed(() => props.usage.usedPercent >= 90)

const progressBarColor = computed(() => (isStorageCritical.value ? '#C60020' : undefined))

const usageText = computed(() => {
	if (props.usage.usedPercent === 100) {
		return 'Você não possui armazenamento disponível para upload das imagens.'
	}

	return `Você possui ${props.usage.availableGbs.toFixed(2)}GB de armazenamento disponível
para upload das imagens. `
})
</script>

<template>
	<div class="grid border border-gray-medium p-8 rounded-lg gap-5 items-center bg-white-neutral">
		<p class="text-s text-neutral-black">{{ usageText }}</p>
		<div class="flex items-center gap-4">
			<progress-bar
				hide-inner-label
				:progresso="usage.usedPercent"
				:completed-color="progressBarColor"
			/>
			<span class="text-default">{{ Math.round(usage.usedPercent) }}%</span>
		</div>
		<button
			class="text-blue-base font-semibold text-sm btn-request"
			:disabled="!isStorageCritical"
			@click="showDialog = true"
		>
			solicitar mais armazenamento
		</button>
		<StorageRequestDialog
			v-if="showDialog"
			@cancel="showDialog = false"
			@confirm="
				showDialog = false
				emit('requestStorage')
			"
		/>
	</div>
</template>

<style scoped>
:deep(.button.secondary) {
	border: none !important;
}

.grid {
	grid-template-columns: 1.5fr 2fr 1fr;
}

.btn-request {
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;
}

.btn-request:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
</style>
